exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error-msg {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 700px;\r\n    font-size: 24px;\r\n}", ""]);
